import abstractModel from "../../core/ShopModel";

let resource = 'retailers/products';

const model = abstractModel(resource);

model.getOne = async (params) => {
  const newResource = `${resource}/${params.id}`;

  return model.get({}, { path: newResource });
};

model.checkSku = (params = {}) => {
  return model.post(params, { path: `${resource}/check_sku` });
};

model.deleteSelected = (params = {}) => {
  return model.remove(params, { path: `${resource}/delete_selected` });
};

export default model;
